import getData from "@/commonJS/getData";
import React from "react";

function isValidText(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

function traverseJson(json: any, data: any): string | undefined {
  try {
    if (!json) return undefined;

    if (isValidText(json?.ariaLabel)) {
      return json.ariaLabel.trim();
    }
    if (json?.fieldType === "image") {
      if (isValidText(json?.alt || json?.imageAlt)) {
        return (json.alt || json.imageAlt).trim();
      } else if (Object.keys(json?.dynamicAlt || {})?.length) {
        return getData(json?.dynamicAlt, data);
      }
    }

    const children = json?.child;

    if (Array.isArray(children) && children?.length) {
      for (const item of children) {
        const result = traverseJson(item, data);
        if (result) return result;
      }
    }

    return undefined;
  } catch (err) {
    throw err;
  }
}

function traverse(node: React.ReactNode | undefined): string | undefined {
  try {
    if (!node) return undefined;

    const { props = {} } = node as any;

    if (props?.field?.fieldType === "link") {
      if (isValidText(props?.field?.alt || props?.field?.imageAlt)) {
        return (props?.field.alt || props?.field.imageAlt).trim();
      } else if (Object.keys(props?.field?.dynamicAlt || {})?.length) {
        return getData(props?.field?.dynamicAlt, props?.globalState);
      }
    }

    if (isValidText(props?.field?.["ariaLabel"])) {
      return props?.field?.["ariaLabel"].trim();
    }

    const children = props?.children;
    if (Array.isArray(props?.formJSON) && props?.formJSON?.length) {
      for (const item of props.formJSON) {
        const result = traverseJson(item, props?.globalState);
        if (result) return result;
      }
    }

    if (children) {
      let result: string | undefined;

      React.Children.forEach(children, (child) => {
        if (result) return;
        result = traverse(child);
      });

      if (result) return result;
    }

    return undefined;
  } catch (err) {
    throw err;
  }
}

export function extractAccessibleLabel(
  children: React.ReactNode
): string | undefined {
  try {
    const result = traverse(children);
    return result;
  } catch (err) {
    return undefined;
  }
}
